import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { Log } from "../../../models/Log";

type Props = {
	setSelectedLog: Function;
	setShowLogModal: Function;
	handleResetButtonClick: Function;
};
export const useLogsOptionsFunctions = ({
	setSelectedLog,
	setShowLogModal,
	handleResetButtonClick,
}: Props) => {
	const getMenuOptions = (data: Log) => {
		let options: MenuOptionType[] = [];
		if (data) {
			options = options.concat([
				{
					name: "View Log",
					key: "view_log",
					onClick: () => {
						setSelectedLog(data);
						setShowLogModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Reset Filter",
					key: "reset_filters",
					onClick: () => {
						handleResetButtonClick();
					},
					icon: <EditIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
